import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDropdownSmall = ({ title, titleId,...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "12px",
	height: "8px",
	viewBox: "0 0 12 8",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			transform: "translate(-665.000000, -505.000000)",
			children: /* @__PURE__ */ _jsxs("g", {
				transform: "translate(659.000000, 497.000000)",
				children: [
					/* @__PURE__ */ _jsx("mask", {
						id: "mask-2gfhjoiglk",
						fill: "white",
						children: /* @__PURE__ */ _jsx("polygon", { points: "7.41 8.59 12 13.17 16.59 8.59 18 10 12 16 6 10" })
					}),
					/* @__PURE__ */ _jsx("g", { fillRule: "nonzero" }),
					/* @__PURE__ */ _jsx("g", {
						mask: "url(#mask-2gfhjoiglk)",
						fill: "#000000",
						fillOpacity: .54,
						children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("rect", {
							x: 0,
							y: 0,
							width: 24,
							height: 24
						}) })
					})
				]
			})
		})
	})]
});
const ForwardRef = forwardRef(SvgDropdownSmall);
export { ForwardRef as ReactComponent };
